import * as apiCall from '../../axios';

let apiVersion = 'v3';

// Get differences between multiple campaign versions
export const getCampaignDifferences = (new_version_id, old_version_id) => {
  return apiCall.sendRequest(`/api/${apiVersion}/campaign_version_differences`, {new_version_id: new_version_id, old_version_id: old_version_id});
};